import React from "react";
import { Phone, CalendarCheck } from "lucide-react";

const MobileCTA = () => {
  const scrollToReservation = () => {
    document.getElementById("reservation")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-200 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] px-4 py-3">
      <div className="flex items-center gap-2 max-w-md mx-auto">
        <a
          href="tel:+33632183554"
          aria-label="Appeler"
          className="flex items-center justify-center h-12 w-12 rounded-full border-2 border-[#1B7B71] text-[#1B7B71] hover:bg-[#1B7B71] hover:text-white transition-colors flex-shrink-0"
        >
          <Phone className="h-5 w-5" />
        </a>
        <button
          onClick={scrollToReservation}
          className="flex-1 flex items-center justify-center gap-2 h-12 bg-[#1B7B71] text-white font-semibold rounded-full hover:bg-[#155f57] transition-colors"
        >
          <CalendarCheck className="h-4 w-4" />
          <span>Réserver une table</span>
        </button>
      </div>
    </div>
  );
};

export default MobileCTA;
